import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

export type ColorMode = 'light' | 'dark' | 'system';

type State = {
  isFocusMode: boolean;
  colorMode: ColorMode;
};

const initialState: State = {
  isFocusMode: false,
  colorMode: 'system',
};

const focusModeSlice = createSlice({
  name: 'focusMode',
  initialState,
  reducers: {
    updateFocusMode(state: State, action: PayloadAction<boolean>) {
      state.isFocusMode = action.payload;
    },
    toggleFocusMode(state: State) {
      state.isFocusMode = !state.isFocusMode;
    },
    updateColorMode(state: State, action: PayloadAction<ColorMode>) {
      state.colorMode = action.payload;
    },
  },
});

export const { updateFocusMode, toggleFocusMode, updateColorMode } = focusModeSlice.actions;

export const selectFocusMode = (state: RootState): boolean => {
  return state.focusMode?.isFocusMode ?? false;
};

export const selectColorMode = (state: RootState): ColorMode => {
  return state.focusMode?.colorMode ?? 'system';
};

export default focusModeSlice.reducer;
